module.exports = __webpack_public_path__ + "static/media/en-US.d9aa8fa7.jpg";